import { OnInit, Component } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';
import { AuthenticationService } from './services/authentication.service';
import { BidderService } from './services/bidder.service';
declare var $: any

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  name = 'Govtow Auctions'
  title = 'OnlineAuction';
  isEmbeddedSearchDetails = false;
  private readonly EMBED_MODE_STORAGE_KEY = 'iframeEmbedMode';
  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private metaTagService: Meta,
    private authenticationService: AuthenticationService,
    private bidderService: BidderService) {
    $(document).ready(function () {
      $('body').tooltip({
        selector: '[data-toggle="tooltip"]'
      })
    });
  }

  ngOnInit() {
    this.checkEmbeddedMode();
    
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    ).subscribe(() => {
      const rt = this.getChild(this.activatedRoute);
      rt.data.subscribe(data => {
        // console.log(data);
        this.titleService.setTitle(data.title)
      });

      // Persist iframe mode so internal route navigation keeps the same shell behavior.
      this.isEmbeddedSearchDetails = this.isSearchdetailsEmbedMode();
    });
    this.titleService.setTitle("Govtow Auction");  
    this.metaTagService.addTags([  
      { name: 'keywords', content: 'Auction, Online Auction, Gov Auctions, Govtow Auctions, Towing Auctions, Towed Vehicle Auction' },  
      { name: 'robots', content: 'index, follow' },
      { name: 'writer', content: 'Govtow Auctions' },  
      { charset: 'UTF-8' } 
    ]);  
    const writer = this.metaTagService.getTag('name=writer');  
    console.log(writer.content); //Govtow Auctions  
  }

  getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }

  }

  private checkEmbeddedMode(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const embedParam = urlParams.get('embed');
    const isEmbedded = embedParam === 'true' || embedParam === '1';
    
    if (isEmbedded) {
      const enterpriseGuid = urlParams.get('GTAEnterpriseGUID');
      
      if (enterpriseGuid) {
        const existingUser: any = this.authenticationService.currentUserValue;
        
        if (!existingUser || existingUser.userid !== 0) {
          this.bidderService.GetSellerDetailsFromGuid(enterpriseGuid).subscribe(
            (response: any) => {
              if (response && response.EnterpriseId) {
                const enterpriseId = response.EnterpriseId;
                
                const embeddedUser: any = {
                  userid: 0,
                  roleid: 3,
                  message: 'Success',
                  username: 'EmbeddedUser',
                  enterpriseid: enterpriseId,
                  groupname: 'Enterprise',
                  rolename: 'Seller',
                  IsDLMS: 1
                };
                
                sessionStorage.setItem('currentUser', JSON.stringify(embeddedUser));
                sessionStorage.setItem('isEmbedded', 'true');
                sessionStorage.setItem('embedEnterpriseId', enterpriseId.toString());
                
                (this.authenticationService as any).currentUserSubject.next(embeddedUser);
              }
            },
            (error) => {
              console.error('Error fetching seller details:', error);
            }
          );
        }
      }
    }
  }

  private isSearchdetailsEmbedMode(): boolean {
    const tree = this.router.parseUrl(this.router.url);
    const embedParam = (tree.queryParams['embed'] || '').toString().toLowerCase();
    const enableEmbed = embedParam === 'true' || embedParam === '1';
    const disableEmbed = embedParam === 'false' || embedParam === '0';

    if (enableEmbed) {
      sessionStorage.setItem(this.EMBED_MODE_STORAGE_KEY, '1');
      return true;
    }

    if (disableEmbed) {
      sessionStorage.removeItem(this.EMBED_MODE_STORAGE_KEY);
      return false;
    }

    return sessionStorage.getItem(this.EMBED_MODE_STORAGE_KEY) === '1';
  }
}
